module.exports = __webpack_public_path__ + "assets/measure_top_vehicle_locations.54218eff.svg";